import { CampoSolicitud } from './campo-solicitud';

export class UnidadSolicitud {

  id: number;
  campos: CampoSolicitud[] = [];
  isUnitMassiveLoad = false;

  constructor() { }

  equals(other: UnidadSolicitud): boolean {
    this.campos.forEach((campo: CampoSolicitud) => {
      if (campo.valor !== other.campos.filter((c: CampoSolicitud) => c.id === campo.id)[0].valor) {
        return false;
      }
    });
    return true;
  }

}
